import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import KpiCard from '../../model-scenarios/components/KpiCard';
import { formatNumber } from '../../reports/reportHelper';

const BenchmarkKpis = ({ overview }) => {
  const { t } = useTranslation();

  const {
    emissionIntensity,
    sectorBenchmark,
    variance,
  } = overview;

  const hasValue = (value) => value !== null && value !== undefined;
  const getVarianceVariant = (band) => {
    if (!band) {
      return 'purple';
    }

    return band;
  };

  const varianceValue = hasValue(variance?.value)
    ? `${formatNumber(variance.value)}${variance?.unit || '%'}`
    : t('No data');

  const varianceUnit = hasValue(variance?.value)
    ? (variance.direction === 'above' ? t('Above benchmark') : t('Below benchmark'))
    : '';

  return (
    <Row className="mb-4">
      <Col md={4}>
        <KpiCard
          title={t('Organization Emission Intensity')}
          value={hasValue(emissionIntensity?.value) ? formatNumber(emissionIntensity.value) : t('No data')}
          unit={hasValue(emissionIntensity?.value) ? emissionIntensity?.unit : ''}
          variant="green"
          level="primary"
        />
      </Col>

      <Col md={4}>
        <KpiCard
          title={t('Sector Average')}
          value={hasValue(sectorBenchmark?.value) ? formatNumber(sectorBenchmark.value) : t('No data')}
          unit={hasValue(sectorBenchmark?.value) ? sectorBenchmark?.unit : ''}
          variant="blue"
          level="primary"
        />
      </Col>

      <Col md={4}>
        <KpiCard
          title={t('Variance %')}
          value={varianceValue}
          unit={varianceUnit}
          variant={getVarianceVariant(variance?.band)}
          level="primary"
        />
      </Col>
    </Row>
  );
};

export default BenchmarkKpis;
